module.exports = __webpack_public_path__ + "static/notebook-users-creative-6a391731516e96835e83be9de12780b6.png";